import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import { useAuth } from '../context/AuthContext';
import './Account.css';

const Account = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchWallet();
    }
  }, [user]);

  const fetchWallet = async () => {
    try {
      const response = await axios.get(`${API_URL}/wallet/me`);
      setWallet(response.data);
    } catch (error) {
      console.error('Error fetching wallet:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-container">
      <div className="container">
        <h1>{t('nav.account')}</h1>
        <div className="account-boxes">
          {user && (
            <div className="account-box wallet-box">
              <div className="account-box-icon">
                <i className="fas fa-wallet"></i>
              </div>
              <h3>{t('account.wallet') || 'Wallet'}</h3>
              {loading ? (
                <p>{t('account.loading') || 'Loading...'}</p>
              ) : (
                <>
                  <p className="wallet-balance">
                    {t('account.balance') || 'Balance'}: <strong>€{wallet?.balance?.toFixed(2) || '0.00'}</strong>
                  </p>
                  <Link to="/wallet" className="wallet-link">
                    {t('account.viewWallet') || 'View Wallet & Transactions'}
                  </Link>
                </>
              )}
            </div>
          )}

          <Link to="/settings" className="account-box">
            <div className="account-box-icon">
              <i className="fas fa-cog"></i>
            </div>
            <h3>{t('nav.settings')}</h3>
            <p>{t('account.settingsDescription') || 'Manage your account settings'}</p>
          </Link>

          <Link to="/orders" className="account-box">
            <div className="account-box-icon">
              <i className="fas fa-clipboard-list"></i>
            </div>
            <h3>{t('nav.orders')}</h3>
            <p>{t('account.ordersDescription') || 'View your orders and receipts'}</p>
          </Link>

          <Link to="/help" className="account-box">
            <div className="account-box-icon">
              <i className="fas fa-question-circle"></i>
            </div>
            <h3>{t('nav.help')}</h3>
            <p>{t('account.helpDescription') || 'Get help and support'}</p>
          </Link>

          <Link to="/information" className="account-box">
            <div className="account-box-icon">
              <i className="fas fa-info-circle"></i>
            </div>
            <h3>{t('account.information') || 'Tietoja'}</h3>
            <p>{t('account.informationDescription') || 'Information about our app'}</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Account;
